export const BREAD_SCRIPT_URL = process.env.NEXT_PUBLIC_BREAD_SCRIPT_URL;
export const BREAD_INTEGRATION_KEY = process.env.NEXT_PUBLIC_BREAD_INTEGRATION_KEY;
